export default __webpack_public_path__ + "static/8-30f39bc7acdc962463122b91ad8e3249.jpg";